import React, { Fragment } from "react";
import { Row, Col, FlexBox } from "~/components/.base/containers";
import { Subheading, BodyText, BodyTextAlt } from "~/components/.base/headings";
import ClockIcon from "~/images/icons/location_clock.svg";

const TruckSchedule = ({
	scheduleData,
	formatTitle,
	formatTime,
	formatAddress,
	maxDepthArr,
}) => {
	return (
		<Row className="schedule-items">
			{scheduleData ? (
				<Fragment>
					<Col className="schedule-col">
						{scheduleData["Sunday"]
							? scheduleData["Sunday"].map((event, i) => (
									<div
										key={i}
										className={`schedule-item ${
											i ===
												scheduleData["Sunday"].length -
													1 &&
											scheduleData["Sunday"].length >=
												maxDepthArr.length
												? "last"
												: ""
										}`}
									>
										<Subheading>
											{formatTitle(event.summary)}
										</Subheading>
										{event.isWithinDistance ? (
											<div class="within-distance">
												Within Range
											</div>
										) : null}
										<FlexBox
											className="time"
											align="center"
										>
											<ClockIcon />
											<BodyTextAlt>
												{formatTime(
													event.start,
													event.end
												)}
											</BodyTextAlt>
										</FlexBox>
										<a
											href={`https://maps.google.com/?q=${formatAddress(
												event.formattedAddress,
												event.location
											)}`}
											target="_/blank"
										>
											<BodyText>
												{formatAddress(
													event.formattedAddress,
													event.location
												)}
											</BodyText>
										</a>
									</div>
							  ))
							: maxDepthArr.map((a, i) => {
									if (i === 0) {
										return (
											<div className="empty-date first">
												<Subheading>
													No events scheduled
												</Subheading>
											</div>
										);
									}
									return (
										<div
											className={`empty-date ${
												i === maxDepthArr.length - 1
													? "last"
													: ""
											}`}
										/>
									);
							  })}
						{scheduleData["Sunday"] &&
						scheduleData["Sunday"].length < maxDepthArr.length
							? maxDepthArr
									.slice(
										0,
										maxDepthArr.length -
											scheduleData["Sunday"].length
									)
									.map((a, i) => (
										<div
											className={`empty-date ${
												i ===
												maxDepthArr.length -
													scheduleData["Sunday"]
														.length -
													1
													? "last"
													: ""
											}`}
										/>
									))
							: null}
					</Col>
					<Col className="schedule-col">
						{scheduleData["Monday"]
							? scheduleData["Monday"].map((event, i) => (
									<div
										className={`schedule-item ${
											i ===
												scheduleData["Monday"].length -
													1 &&
											scheduleData["Monday"].length >=
												maxDepthArr.length
												? "last"
												: ""
										}`}
									>
										<Subheading>
											{formatTitle(event.summary)}
										</Subheading>
										{event.isWithinDistance ? (
											<div class="within-distance">
												Within Range
											</div>
										) : null}
										<FlexBox
											className="time"
											align="center"
										>
											<ClockIcon />
											<BodyTextAlt>
												{formatTime(
													event.start,
													event.end
												)}
											</BodyTextAlt>
										</FlexBox>
										<a
											href={`https://maps.google.com/?q=${formatAddress(
												event.formattedAddress,
												event.location
											)}`}
											target="_/blank"
										>
											<BodyText>
												{formatAddress(
													event.formattedAddress,
													event.location
												)}
											</BodyText>
										</a>
									</div>
							  ))
							: maxDepthArr.map((a, i) => {
									if (i === 0) {
										return (
											<div className="empty-date first">
												<Subheading>
													No events scheduled
												</Subheading>
											</div>
										);
									}
									return (
										<div
											className={`empty-date ${
												i === maxDepthArr.length - 1
													? "last"
													: ""
											}`}
										/>
									);
							  })}
						{scheduleData["Monday"] &&
						scheduleData["Monday"].length < maxDepthArr.length
							? maxDepthArr
									.slice(
										0,
										maxDepthArr.length -
											scheduleData["Monday"].length
									)
									.map((a, i) => (
										<div
											className={`empty-date ${
												i ===
												maxDepthArr.length -
													scheduleData["Monday"]
														.length -
													1
													? "last"
													: ""
											}`}
										/>
									))
							: null}
					</Col>
					<Col className="schedule-col">
						{scheduleData["Tuesday"]
							? scheduleData["Tuesday"].map((event, i) => (
									<div
										className={`schedule-item ${
											i ===
												scheduleData["Tuesday"].length -
													1 &&
											scheduleData["Tuesday"].length >=
												maxDepthArr.length
												? "last"
												: ""
										}`}
									>
										<Subheading>
											{formatTitle(event.summary)}
										</Subheading>
										{event.isWithinDistance ? (
											<div class="within-distance">
												Within Range
											</div>
										) : null}
										<FlexBox
											className="time"
											align="center"
										>
											<ClockIcon />
											<BodyTextAlt>
												{formatTime(
													event.start,
													event.end
												)}
											</BodyTextAlt>
										</FlexBox>
										<a
											href={`https://maps.google.com/?q=${formatAddress(
												event.formattedAddress,
												event.location
											)}`}
											target="_/blank"
										>
											<BodyText>
												{formatAddress(
													event.formattedAddress,
													event.location
												)}
											</BodyText>
										</a>
									</div>
							  ))
							: maxDepthArr.map((a, i) => {
									if (i === 0) {
										return (
											<div className="empty-date first">
												<Subheading>
													No events scheduled
												</Subheading>
											</div>
										);
									}
									return (
										<div
											className={`empty-date ${
												i === maxDepthArr.length - 1
													? "last"
													: ""
											}`}
										/>
									);
							  })}
						{scheduleData["Tuesday"] &&
						scheduleData["Tuesday"].length < maxDepthArr.length
							? maxDepthArr
									.slice(
										0,
										maxDepthArr.length -
											scheduleData["Tuesday"].length
									)
									.map((a, i) => (
										<div
											className={`empty-date ${
												i ===
												maxDepthArr.length -
													scheduleData["Tuesday"]
														.length -
													1
													? "last"
													: ""
											}`}
										/>
									))
							: null}
					</Col>
					<Col className="schedule-col">
						{scheduleData["Wednesday"]
							? scheduleData["Wednesday"].map((event, i) => (
									<div
										className={`schedule-item ${
											i ===
												scheduleData["Wednesday"]
													.length -
													1 &&
											scheduleData["Wednesday"].length >=
												maxDepthArr.length
												? "last"
												: ""
										}`}
									>
										<Subheading>
											{formatTitle(event.summary)}
										</Subheading>
										{event.isWithinDistance ? (
											<div class="within-distance">
												Within Range
											</div>
										) : null}
										<FlexBox
											className="time"
											align="center"
										>
											<ClockIcon />
											<BodyTextAlt>
												{formatTime(
													event.start,
													event.end
												)}
											</BodyTextAlt>
										</FlexBox>
										<a
											href={`https://maps.google.com/?q=${formatAddress(
												event.formattedAddress,
												event.location
											)}`}
											target="_/blank"
										>
											<BodyText>
												{event.formattedAddress
													? event.formattedAddress
													: event.location}
											</BodyText>
										</a>
									</div>
							  ))
							: maxDepthArr.map((a, i) => {
									if (i === 0) {
										return (
											<div className="empty-date first">
												<Subheading>
													No events scheduled
												</Subheading>
											</div>
										);
									}
									return (
										<div
											className={`empty-date ${
												i === maxDepthArr.length - 1
													? "last"
													: ""
											}`}
										/>
									);
							  })}
						{scheduleData["Wednesday"] &&
						scheduleData["Wednesday"].length < maxDepthArr.length
							? maxDepthArr
									.slice(
										0,
										maxDepthArr.length -
											scheduleData["Wednesday"].length
									)
									.map((a, i) => (
										<div
											className={`empty-date ${
												i ===
												maxDepthArr.length -
													scheduleData["Wednesday"]
														.length -
													1
													? "last"
													: ""
											}`}
										/>
									))
							: null}
					</Col>
					<Col className="schedule-col">
						{scheduleData["Thursday"]
							? scheduleData["Thursday"].map((event, i) => (
									<div
										className={`schedule-item ${
											i ===
												scheduleData["Thursday"]
													.length -
													1 &&
											scheduleData["Thursday"].length >=
												maxDepthArr.length
												? "last"
												: ""
										}`}
									>
										<Subheading>
											{formatTitle(event.summary)}
										</Subheading>
										{event.isWithinDistance ? (
											<div class="within-distance">
												Within Range
											</div>
										) : null}
										<FlexBox
											className="time"
											align="center"
										>
											<ClockIcon />
											<BodyTextAlt>
												{formatTime(
													event.start,
													event.end
												)}
											</BodyTextAlt>
										</FlexBox>
										<a
											href={`https://maps.google.com/?q=${formatAddress(
												event.formattedAddress,
												event.location
											)}`}
											target="_/blank"
										>
											<BodyText>
												{formatAddress(
													event.formattedAddress,
													event.location
												)}
											</BodyText>
										</a>
									</div>
							  ))
							: maxDepthArr.map((a, i) => {
									if (i === 0) {
										return (
											<div className="empty-date first">
												<Subheading>
													No events scheduled
												</Subheading>
											</div>
										);
									}
									return (
										<div
											className={`empty-date ${
												i === maxDepthArr.length - 1
													? "last"
													: ""
											}`}
										/>
									);
							  })}
						{scheduleData["Thursday"] &&
						scheduleData["Thursday"].length < maxDepthArr.length
							? maxDepthArr
									.slice(
										0,
										maxDepthArr.length -
											scheduleData["Thursday"].length
									)
									.map((a, i) => (
										<div
											className={`empty-date ${
												i ===
												maxDepthArr.length -
													scheduleData["Thursday"]
														.length -
													1
													? "last"
													: ""
											}`}
										/>
									))
							: null}
					</Col>
					<Col className="schedule-col">
						{scheduleData["Friday"]
							? scheduleData["Friday"].map((event, i) => (
									<div
										className={`schedule-item ${
											i ===
												scheduleData["Friday"].length -
													1 &&
											scheduleData["Friday"].length >=
												maxDepthArr.length
												? "last"
												: ""
										}`}
									>
										<Subheading>
											{formatTitle(event.summary)}
										</Subheading>
										{event.isWithinDistance ? (
											<div class="within-distance">
												Within Range
											</div>
										) : null}
										<FlexBox
											className="time"
											align="center"
										>
											<ClockIcon />
											<BodyTextAlt>
												{formatTime(
													event.start,
													event.end
												)}
											</BodyTextAlt>
										</FlexBox>
										<a
											href={`https://maps.google.com/?q=${formatAddress(
												event.formattedAddress,
												event.location
											)}`}
											target="_/blank"
										>
											<BodyText>
												{formatAddress(
													event.formattedAddress,
													event.location
												)}
											</BodyText>
										</a>
									</div>
							  ))
							: maxDepthArr.map((a, i) => {
									if (i === 0) {
										return (
											<div className="empty-date first">
												<Subheading>
													No events scheduled
												</Subheading>
											</div>
										);
									}
									return (
										<div
											className={`empty-date ${
												i === maxDepthArr.length - 1
													? "last"
													: ""
											}`}
										/>
									);
							  })}
						{scheduleData["Friday"] &&
						scheduleData["Friday"].length < maxDepthArr.length
							? maxDepthArr
									.slice(
										0,
										maxDepthArr.length -
											scheduleData["Friday"].length
									)
									.map((a, i) => (
										<div
											className={`empty-date ${
												i ===
												maxDepthArr.length -
													scheduleData["Friday"]
														.length -
													1
													? "last"
													: ""
											}`}
										/>
									))
							: null}
					</Col>
					<Col className="schedule-col">
						{scheduleData["Saturday"]
							? scheduleData["Saturday"].map((event, i) => (
									<div
										className={`schedule-item ${
											i ===
												scheduleData["Saturday"]
													.length -
													1 &&
											scheduleData["Saturday"].length >=
												maxDepthArr.length
												? "last"
												: ""
										}`}
									>
										<Subheading>
											{formatTitle(event.summary)}
										</Subheading>
										{event.isWithinDistance ? (
											<div class="within-distance">
												Within Range
											</div>
										) : null}
										<FlexBox
											className="time"
											align="center"
										>
											<ClockIcon />
											<BodyTextAlt>
												{formatTime(
													event.start,
													event.end
												)}
											</BodyTextAlt>
										</FlexBox>
										<a
											href={`https://maps.google.com/?q=${formatAddress(
												event.formattedAddress,
												event.location
											)}`}
											target="_/blank"
										>
											<BodyText>
												{formatAddress(
													event.formattedAddress,
													event.location
												)}
											</BodyText>
										</a>
									</div>
							  ))
							: maxDepthArr.map((a, i) => {
									if (i === 0) {
										return (
											<div className="empty-date first">
												<Subheading>
													No events scheduled
												</Subheading>
											</div>
										);
									}
									return (
										<div
											className={`empty-date ${
												i === maxDepthArr.length - 1
													? "last"
													: ""
											}`}
										/>
									);
							  })}
						{scheduleData["Saturday"] &&
						scheduleData["Saturday"].length < maxDepthArr.length
							? maxDepthArr
									.slice(
										0,
										maxDepthArr.length -
											scheduleData["Saturday"].length
									)
									.map((a, i) => (
										<div
											className={`empty-date ${
												i ===
												maxDepthArr.length -
													scheduleData["Saturday"]
														.length -
													1
													? "last"
													: ""
											}`}
										/>
									))
							: null}
					</Col>
				</Fragment>
			) : null}
		</Row>
	);
};

export default TruckSchedule;
